import { adminApi } from '../../api/admin';
import { useAsync, Table, Banner } from './ui';

export default function AuditAdmin() {
  const { data, error, loading } = useAsync(() => adminApi.auditLog(300), [], 'audit');
  return (
    <div>
      <h1>Audit log</h1>
      <p className="muted">Every reading and every configuration change, newest first. Read-only.</p>
      <Banner error={error} />
      {loading && <div className="spinner" />}
      {data && (
        <Table
          rows={data.rows}
          columns={['Timestamp', 'Actor ID', 'Actor Role', 'Action', 'Entity Type', 'Entity ID', 'After (JSON)', 'Context']}
          empty="No audit entries yet."
        />
      )}
    </div>
  );
}
